import { render, staticRenderFns } from "./loginLayout.vue?vue&type=template&id=d2aee274&scoped=true&"
import script from "./loginLayout.vue?vue&type=script&lang=js&"
export * from "./loginLayout.vue?vue&type=script&lang=js&"
import style0 from "./loginLayout.vue?vue&type=style&index=0&id=d2aee274&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2aee274",
  null
  
)

export default component.exports